module.exports = __webpack_public_path__ + "img/200-px@3x.7958b003.png";